import styled from "styled-components";
import { responsive } from "../../mixins";

export const Wrapper = styled.section`
  position: relative;
  .squar {
    position: absolute;
    top: -20px;
    right: -20px;
    width: 80px;
    height: 80px;
    border-radius: 10px;
    z-index: 0;
    transform: rotate(45deg);
    background-image: radial-gradient(
      circle,
      white,
      white,
      var(--primary-200),
      var(--primary-200),
      var(--primary-100)
    );
    background-size: 1000%;
    animation: animate 10s linear infinite;

    @keyframes animate {
      0% {
        background-position: 0% 100%;
      }
      5% {
        background-position: 100% 0%;
      }
      100% {
        background-position: 0% 100%;
      }
    }
  }
  .align-right {
    top: -20px;
    right: -20px;
  }
  .align-left {
    top: -30px;
    left: -30px;
  }
  h2 {
    position: relative;
    ${responsive.mobile.standard`
      font-size: 2rem;
    `}
  }
  h2.text-left {
    text-align: left;
  }
  h2.text-right {
    text-align: right;
  }

  @keyframes diagonal {
    0% {
      background-position: 0% 50%;
    }
    100% {
      background-position: 100% 50%;
    }
  }
`;
